/**
 *
 * Asynchronously loads the component for AssetByType
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetByType = lazyLoad(
  () => import('./index'),
  module => module.AssetByType,
);
